<app-header></app-header>
<main class="main-content">
  <!------main-content------>
  <!-----------page_title--------------->

  <!-----------footer--------------->
  <section class="contact_page pdb_70 pdt_100">
    <div class="container">
      <div class="row">
        <!---------row----------->

        <div iv class="col-lg-6">
          <img src="assets/image/track.png" class="img-fluid" />
        </div>

        <div class="col-lg-6 col-md-12 mx-auto">
          <!---------col----------->
          <div class="contact_us_form">
            <h2 class="update-recod-heading text-left mt-5">Track Result</h2>
            <div class="form_box type_one">
              <form
                [formGroup]="appointmentForm"
                (ngSubmit)="submitForm(appointmentForm.value)"
              >
                <div class="messages"></div>
                <div class="controls">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <input
                          type="text"
                          formControlName="appointmentId"
                          class="percent_100 login_input_padding"
                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; appointmentForm.controls.appointmentId.errors }"
                          placeholder="Appointment ID"
                        />
                        <div
                          *ngIf="submitted &amp;&amp; appointmentForm.controls.appointmentId.errors"
                          class="form-text text-danger"
                        >
                          <div
                            *ngIf="
                              appointmentForm.controls.appointmentId.errors
                                .minlength
                            "
                          >
                            A minimum of 7 character reuired
                          </div>
                          <div
                            *ngIf="
                              appointmentForm.controls.appointmentId.errors
                                .pattern
                            "
                          >
                            Please enter a valid Appointment ID
                          </div>
                          <div
                            *ngIf="
                              appointmentForm.controls.appointmentId.errors
                                .required
                            "
                          >
                            Appointment ID is reuired
                          </div>
                        </div>

                        <!-- <div class="help-block with-errors"></div> -->
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="form-group text-center mt-4">
                        <button
                          type="submit"
                          class="theme_btn tp_two logo-button-website"
                        >
                          Fetch Record
                        </button>
                        <button
                          type="button"
                          id="loadResultModal"
                          (click)="viewModal(resultmodal)"
                          class="theme_btn tp_two logo-button-website d-none"
                        >
                          Fetch Record
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!---------col-end---------->
        </div>

        <!----------row-end---------->
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</main>
<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>

<ng-template #resultmodal let-modal>
  <!-- Modal -->
  <div class="">
    <div class="">
      <div class="modal-content">
        <div class="modal-header-custom">
          <h5 class="modal-title" id="exampleModalLongTitle">Result</h5>
          <button type="button" (click)="modal.close('Save click')">
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
        <div class="" *ngIf="resultDetails != null">
          <!-- track result  start -->

          <div class="container-fluid track-header-bg">
            <div class="row">
              <div class="col-lg-4 pt-3 pb-3">
                <img src="assets/image/logo-eg.png" width="150" />
              </div>
              <div class="col-lg-8 pt-3 pb-3">
                <div class="clinic-name">
                  <strong>{{ resultDetails.center_name }}</strong>
                  <br />
                  {{ resultDetails.center_address }}<br />
                  A member of the EG COVID-19 Laboratory consortium equatorial
                  guinea<br />
                  <strong>Virology pcr test report for COVID-19</strong><br />
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid font-12">
            <div class="row">
              <div class="col-lg-6">
                <table border="0" width="100%" align="center">
                  <tr>
                    <td colspan="3">
                      <br /><strong
                        >Date: {{ resultDetails.booking_date }}</strong
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Name:<br />
                      Sample Collected on:<br />
                      Date of birth: <br />
                    </td>
                    <td>
                      {{
                        resultDetails.first_name +
                          " " +
                          resultDetails.middle_name +
                          " " +
                          resultDetails.last_name
                      }}<br />
                      {{
                        resultDetails.sample_collected_date
                          | date: "dd, MMM, yyyy, hh:mm"
                      }}
                      <br />
                      {{ resultDetails.dob | date: "dd, MMM, yyyy" }} <br />
                    </td>
                    <td align="right">
                      <img [src]="resultDetails.qrcode_filepath" width="50" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Sex: <br />
                      Address: <br />
                      Phone no: <br />
                      Email: <br />
                      Nationality: <br />
                    </td>

                    <td colspan="3">
                      {{ resultDetails.gender == "MALE" ? "M" : "F" }} <br />
                      {{ resultDetails.address_residential }} <br />
                      {{ resultDetails.phone }} <br />
                      {{ resultDetails.email }} <br />
                      {{ resultDetails.nationality }} <br />
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-lg-6">
                <table border="0" width="100%" align="left">
                  <tr>
                    <td colspan="3">
                      <br />
                      <strong>Sample(s)</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">Screening</td>
                  </tr>

                  <tr>
                    <td>Collected Via</td>
                    <td>
                      {{ resultDetails.collected_via }}
                    </td>
                  </tr>
                  <tr>
                    <td>Specimen Type</td>
                    <td>
                      {{ resultDetails.specimen_type }}
                    </td>
                  </tr>
                  <!-- <tr>
                                        <td>
                                            Blood
                                        </td>
                                        <td>
                                            -
                                        </td>
                                    </tr> -->
                  <tr>
                    <td>Others</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Date of result:</td>
                    <td>
                      {{ resultDetails.result_date | date }}
                    </td>
                  </tr>
                  <tr>
                    <td>Positive</td>
                    <td>
                      {{
                        resultDetails.status == "POSITIVE" ? "POSITIVE" : "-"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Negative</td>
                    <td>
                      {{
                        resultDetails.status == "NEGATIVE" ? "NEGATIVE" : "-"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Inconclusive</td>
                    <td>-</td>
                  </tr>
                </table>
              </div>

              <div class="col-lg-12">
                <br />
                <table
                  class="table table-responsive"
                  width="100%"
                  border="0"
                  align="left"
                  cellpadding="15"
                >
                  <tr>
                    <td align="left" style="font-size: 15px">
                      <strong>Result</strong>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>S/N</strong>
                    </td>

                    <td>
                      <strong>TEST DONE</strong>
                    </td>

                    <td>
                      <strong>LAB CODE (SPECIMEN USED) </strong>
                    </td>

                    <td>
                      <strong>REFERENCE RANGE </strong>
                    </td>

                    <td>
                      <strong>TEST VALUE </strong>
                    </td>

                    <td>
                      <strong>COMMENT</strong>
                    </td>
                  </tr>

                  <tr>
                    <td>01</td>

                    <td>UY−HaR FOR JAYS−COV−2</td>

                    <td>CJF/HG-St/40/1132</td>

                    <td>4</td>

                    <td>ABOVE-CUT OFF</td>

                    <td>NEGATIVE</td>
                  </tr>
                </table>
                <br />
              </div>

              <div class="col-lg-12">
                <table
                  width="100%"
                  border="0"
                  align="left"
                  cellpadding="15"
                  style="height: 80px"
                >
                  <tr>
                    <td>
                      <table width="100%" border="0" align="left">
                        <tbody>
                          <tr>
                            <td align="left" style="font-size: 15px">
                              <strong>General comment</strong>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {{ resultDetails.status }} for Sars-cov-2
                              (Covid-19) AB at
                              {{
                                resultDetails.booking_time +
                                  " " +
                                  resultDetails.date
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="col-lg-12">
                <table
                  width="100%"
                  border="0"
                  align="left"
                  cellpadding="15"
                  style="height: 20px"
                >
                  <tr>
                    <td>
                      <img src="assets/image/signature.png" width="50" /><br />
                      Signature
                    </td>
                  </tr>
                </table>
              </div>

              <div class="col-lg-12">
                <table
                  width="100%"
                  border="0"
                  cellpadding="15"
                  style="height: 90px"
                >
                  <tr>
                    <td align="left">
                      <strong>Name:</strong><br />
                      <strong>Phone:</strong><br />
                      <strong>Designation:</strong>
                    </td>
                    <td>
                      {{ resultDetails.lab_attendant_name }} <br />
                      {{ resultDetails.lab_attendant_phone }} <br />
                      Head of laboratory Department
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="container-fluid track-footer-bg">
            <div class="row">
              <div class="col-lg-12">
                <table
                  width="100%"
                  border="0"
                  cellpadding="5"
                  style="height: 40px"
                >
                  <tr>
                    <td>Health care, equatorial guinea</td>
                    <td>Phone: {{ resultDetails.center_phone }}</td>
                    <td>Email: {{ resultDetails.center_email }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <!-- track result end-->
        </div>
        <div class="text-center pb-5 mt-3">
          <button type="button" class="theme_btn tp_two logo-button-website">
            Download Report
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
